import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import {labels} from '../../../../util/utils';
import EllipsesControl from '../../EllipsesControl/EllipsesControl';
import AssociatedRiskAccountList from './AssociatedRiskAccountsList';
import RiskFactorsSummaryList from '../../CanvasForm/Bodies/Common/RiskFactorsSummaryList';

const AssociatedRiskItem = (props) => {
	// Local States.
	const [associatedRisks, setAssociatedRisks] = useState([]);

	useEffect(() => {
		const result = _.orderBy(props.risks, [(risk) => risk.riskName.toLowerCase()], ['asc']);
		setAssociatedRisks(result);
	}, [props.risks]);

	return (
		<>
			{associatedRisks.map((x) => {
				return (
					<li className="risk-list">
						<section className="risk-name-summary">{labels.labelRiskName}</section>
						<span className="risk-name">
							<EllipsesControl
								className={'risk-name-content'}
								content={x.riskName}
								tooltip={x.riskName}
								tooltipClass="tooltipCustomWidth"
							/>
						</span>
						<RiskFactorsSummaryList riskFactorsList={x.riskFactorRelations} />
						<span className="accountassertion-label">{labels.assessRiskAccountsAndRelatedAssertions}</span>
						<AssociatedRiskAccountList assertionList={x.assertionsGroupedByRiskTypes} />
					</li>
				);
			})}
		</>
	);
};

export default AssociatedRiskItem;
